/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Play_PreviewInputs */

const en_play_preview = /** @type {(inputs: Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Preview`)
};

const id_play_preview = /** @type {(inputs: Play_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putar Pratinjau`)
};

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const es_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const fr_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const de_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const ja_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const zh_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const ar_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const it_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const ru_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const pt_play_preview = en_play_preview;

/** @type {(inputs: Play_PreviewInputs) => LocalizedString} */
const ko_play_preview = en_play_preview;

/**
* | output |
* | --- |
* | "Play Preview" |
*
* @param {Play_PreviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const play_preview = /** @type {((inputs?: Play_PreviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Play_PreviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_play_preview(inputs)
	if (locale === "es") return es_play_preview(inputs)
	if (locale === "fr") return fr_play_preview(inputs)
	if (locale === "de") return de_play_preview(inputs)
	if (locale === "ja") return ja_play_preview(inputs)
	if (locale === "zh") return zh_play_preview(inputs)
	if (locale === "ar") return ar_play_preview(inputs)
	if (locale === "id") return id_play_preview(inputs)
	if (locale === "it") return it_play_preview(inputs)
	if (locale === "ru") return ru_play_preview(inputs)
	if (locale === "pt") return pt_play_preview(inputs)
	return ko_play_preview(inputs)
});